import React from 'react'
// import { get } from '../modules/fetch'
import Loading from './Loading'
import { If } from '../modules/helpers'
import { Link } from 'react-router-dom'
import Icon from './Icon'
import useData from '../hooks/useData'

const byUnavailableDate = (a, b) => {
    const ad = a.unavailable_date.replace('-', '')
    const bd = b.unavailable_date.replace('-', '')
    return (ad > bd && 1) || (ad === bd && '0') || -1
}

const Unavailable = (props) => {
    const { data: unavailable_links, isLoading } = useData('provider/amazon/unavailable_links?scope=list')
    //const [status, setStatus] = useState((isLoading && 'loading') || 'ready')

    return (
        <React.Fragment>
            <h2 className="mb-3">Unavailable product links</h2>

            {(unavailable_links && Array.isArray(unavailable_links) && (
                <table className="table">
                    <tbody>
                        {unavailable_links.sort(byUnavailableDate).map((link) => (
                            <tr key={`no-available-link-${link.id}`}>
                                <td>{(link.image_url && <img alt="" style={{ maxWidth: '4rem' }} className="img-fluid" src={link.image_url} />) || null}</td>
                                <td>
                                    <div className="float-right text-center">
                                        {(link.href && (
                                            <React.Fragment>
                                                <a
                                                    className="btn btn-light d-block"
                                                    href={
                                                        link.href.substring(0, link.href.indexOf('SubscriptionId=')) +
                                                        link.href.substring(link.href.indexOf('&creative=') + 1)
                                                    }
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Icon name="external" /> Check on {link.provider}
                                                </a>
                                            </React.Fragment>
                                        )) ||
                                            null}
                                        <small>
                                            {link.external_id}
                                            <br />
                                        </small>
                                    </div>
                                    {(link.site_label && (
                                        <React.Fragment>
                                            <strong>
                                                <Link to={`/site/view/${link.site_id}`}>{link.site_label}</Link>
                                            </strong>
                                            :{' '}
                                        </React.Fragment>
                                    )) ||
                                        null}
                                    <Link to={`/article/edit/${link.article_id}`}>{link.article_title}</Link>
                                    <br />
                                    {link.label}
                                    <br />
                                </td>
                                <td>{link.unavailable_date}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )) || (
                <If condition={isLoading}>
                    <Loading />
                </If>
            )}
        </React.Fragment>
    )
}

export default Unavailable
